var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"focus:outline-none md:w-full w-full md:px-0",on:{"click":function($event){return _vm.$emit('onPress')}}},[_c('div',{staticClass:"bg_color_btn px-4 py-2"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }